import { h } from 'vue';

import { Text } from '@/utils';

export default {
    // functional: true,

    props:
    {
        divider:
        {
            type: Boolean,
            default: false,
        },

        gutter:
        {
            type: String,
            default: null, // 'small', 'medium', 'large', 'collapse'
        },

        matchHeight:
        {
            type: Boolean,
            default: false,
        },

        divClass:
        {
            type: String,
            default: ''
        }
    },

    render()
    {
        return h(
            'div',

            {
                // staticClass: data.staticClass,

                class: Text.joinClass(
                    'vh-grid',
                    this.gutter && `vh-grid-${this.gutter}`,
                    this.divider && 'vh-grid-divider',
                    this.matchHeight && 'vh-grid-match',
                    this.divClass
                ),
            },

            this.$slots
        );
    },
};
